
import { Vue, Component, Prop } from "vue-property-decorator";

import GET_CERTIFICATIONS from "@/apollo/profile/certifications/GetCertifications.gql";

import ProfileCertificationCard from "@/components/profile/certifications/ProfileCertificationCard.vue";
import CertificationModal from "@/components/profile/certifications/CertificationModal.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import { User_Certification } from "@/generated/graphql";

@Component({
  components: {
    ProfileCertificationCard,
    CertificationModal,
    UIButton,
    FormWrapper,
    LoadingOverlay,
  },
  apollo: {
    certifications: {
      query: GET_CERTIFICATIONS,
      variables() {
        return {
          id: this.userId,
        };
      },
      update: (data) => {
        return data.user_by_pk.certifications;
      },
    },
  },
})
export default class ProfileCertification extends Vue {
  @Prop({ type: String, required: true }) readonly userId!: string;

  certifications?: User_Certification[] = undefined;

  isModalOpen: boolean = false;

  showModal(): void {
    this.isModalOpen = true;
  }

  refresh(): void {
    this.$apollo.queries.certifications.refetch();
    this.$emit("update");
  }
}
